import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "feedback",
  "use": "feedback-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"feedback\"><style>#feedback .st0{fill:#fff}</style><path d=\"M256 32c141.4 0 256 93.1 256 208S397.4 448 256 448c-13.6 0-26.9-.9-39.9-2.5-55 55-120.6 64.9-184.1 66.3v-13.5c34.3-16.8 64-47.4 64-82.3 0-4.9-.4-9.7-1.1-14.3C37 363.5 0 305.3 0 240 0 125.1 114.6 32 256 32z\" /><path class=\"st0\" d=\"M342.6 158c-21.2-23.1-51.6-37.6-85.4-37.6-63.9 0-115.8 51.8-115.8 115.8h21.7c0-51.9 42.1-94 94-94 27.8 0 52.8 12.1 70 31.3l-33.8 33.8H373v-79.6L342.6 158zM351.3 236.1c0 51.9-42.1 94-94 94-27.8 0-52.8-12.1-70-31.3l33.8-33.8h-79.6v79.6l30.4-30.4c21.2 23.1 51.6 37.6 85.4 37.6 63.9 0 115.8-51.8 115.8-115.8h-21.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/feedback.svg
// module id = iiyF
// module chunks = 1